import { createClient } from '@supabase/supabase-js'

// Read variables using VUE_APP_ prefix
const supabaseUrl = process.env.VUE_APP_SUPABASE_URL
const supabaseAnonKey = process.env.VUE_APP_SUPABASE_ANON_KEY

// Add checks and logging
if (!supabaseUrl) {
  console.error("ERROR: VUE_APP_SUPABASE_URL is not defined! Check your .env file and restart the server.");
}
if (!supabaseAnonKey) {
  console.error("ERROR: VUE_APP_SUPABASE_ANON_KEY is not defined! Check your .env file and restart the server.");
}

// Initialize client - it might still return a client even if keys are slightly wrong,
// but subsequent calls will fail. The checks above are more direct.
export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Log the initialized client (or potential error)
console.log("Supabase client initialized:", supabase ? 'OK' : 'FAILED - Check URL/Key');